<template>
    <div class="filter-condition-container">
        <template v-if="labelPosition !== 'FALSE'">
            <template v-if="labelPosition === 'TOP'">
                <el-form :model="formSearchObj" label-position="top" ref="formSearchRef" class="label-position-top">
                    <el-row :gutter="20">
                        <el-col :span="12" v-for="(item, index) in Object.keys(formSearchItem)" :key="`el-form-item-${index}`">
                            <el-form-item :prop="item" :label="formSearchItem[item].labelName">
                                <template v-if="formSearchItem[item].formType === 'input'">
                                    <el-input v-model="formSearchObj[item]" :placeholder="`请输入${formSearchItem[item].labelName}`" clearable></el-input>
                                </template>
                                <template v-if="formSearchItem[item].formType === 'inputSlot'">
                                    <el-input v-model="formSearchObj[item]" :placeholder="`请输入${formSearchItem[item].labelName}`" clearable>
                                        <template slot="append">{{ formSearchItem[item].slotText }}</template>
                                    </el-input>
                                </template>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="text-center" :style="{ 'margin': '10px 0' }">
                        <el-button type="primary" size="small" icon="el-icon-search" @click="searchForm">查询</el-button>
                        <el-button type="primary" size="small" icon="el-icon-refresh-right" plain @click="resetForm">重置</el-button>
                    </div>
                </el-form>
            </template>
            <template v-else>
                <el-form :model="formSearchObj" inline label-position="left" ref="formSearchRef" class="label-position-left">
                    <el-form-item v-for="(item, index) in Object.keys(formSearchItem)" :key="`el-form-item-${index}`" :prop="item">
                        <template v-if="formSearchItem[item].formType === 'input'">
                            <el-input v-model="formSearchObj[item]" :style="{ 'minWidth': '300px'}" :placeholder="`请输入${formSearchItem[item].labelName}`" clearable></el-input>
                        </template>
                        <template v-if="formSearchItem[item].formType === 'inputSlot'">
                            <el-input v-model="formSearchObj[item]" :placeholder="`请输入${formSearchItem[item].labelName}`" clearable>
                                <template slot="append">{{ formSearchItem[item].slotText }}</template>
                            </el-input>
                        </template>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="" icon="el-icon-search" @click="searchForm">查询</el-button>
                        <el-button type="primary" size="" icon="el-icon-refresh-right" plain @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </template>
        </template>
        <el-form :model="searchObj" label-position="right" ref="filterSearchRef">
            <div v-for="(item, index) in Object.keys(searchObj)" :key="`form-item-${index}`" :class="filterLabel[item]['type'] !== 'moreSelect' ? 'filter-form' : 'filter-form filter-form-flex'">
                <div class="filter-label">{{ `${filterLabel[item]['label']}：` }}</div>
                <template v-if="filterLabel[item]['type'] === 'moreSelect'">
                    <el-select class="filter-select" v-model="ele['value']" placeholder="请选择" v-for="(ele, indexs) in filterCondition[item]" :key="`el-select-${indexs}`" clearable @change="((val) => { moreSelectChange(val, ele['prop']) })" :disabled="ele['isDisabeld'] ? ele['isDisabeld'] : false">
                        <el-option v-for="(res, indexk) in ele['data']" :key="`el-option-${indexs}-${indexk}`" :label="res['label']" :value="res['value']"></el-option>
                    </el-select>
                </template>
                <template v-if="filterLabel[item]['type'] === 'select'">

                </template>
                <template v-if="filterLabel[item]['type'] === 'default'">
                    <div class="filter-content">
                        <span :class="['filter-item-span', ele.value === searchObj[item] ? 'active' : '']" :key="`tag-item-${index}-${eIdx}`" v-for="(ele, eIdx) in filterCondition[item]" @click="filterItemEvent($event, item, index, ele)">{{ ele.label }}</span>
                    </div>
                    <div class="filter-toggle">
                        <template v-if="filterToggle[item]">
                            <i class="toggle el-icon-arrow-down" data-flag="false" @click="toggleContent(index)"></i>
                        </template>
                    </div>
                </template>
            </div>
        </el-form>
        <template v-if="filterSort.length !== 0">
            <el-divider></el-divider>
            <div class="filter-sort">
                <el-link v-for="(item, index) in filterSort" :key="`el-link-item-${index}`" :type="index=== 0 ? 'primary' : ''" 
                    :underline="false" @click="filterSortEvent($event, index, item)" :data-flag="`${index === 0 ? 1 : 0}`" :data-sort="item.sort">
                    {{ item.label }}<i @click.stop :class="['el-icon--right', index === 0 ? 'el-icon-caret-bottom' : 'el-icon-d-caret']"></i>
                </el-link>
            </div>
        </template>
    </div>
</template>

<script>
import { isEmpty } from '@/utils/filters'
export default {
    name: 'filterConditionContainer',
    props: {
        labelPosition: { type: String, default: () => { return 'TOP' }, required: true },
        formSearchObj: { type: Object, default: () => { return {} }, required: false },
        formSearchItem: { type: Object, default: () => { return {} }, required: false },
        filterCondition: { type: Object, default: () => { return {} }, required: true },
        filterLabel: { type: Object, default: () => { return {} }, required: true },
        filterSearchObj: { type: Object, default: () => { return {} }, required: false },
        filterConditionForm: { type: Object, default: () => { return {} }, required: false },
        filterToggle: { type: Object, default: () => { return {} }, required: true },
        filterSort: { type: Array, default: () => { return [] }, required: false },
    },
    data() {
        return {
            searchObj: {},
            sortType: "DESC",
            eventTargetRecord: "",
            selectedObj: {},
            // filterSort: [
            //     { label: '综合排序', sort: 'ALL' },
            //     { label: '融资金额', sort: 'RZJE' },
            //     { label: '融资利率', sort: 'RZLL' },
            //     { label: '融资期限', sort: 'RZQX' },
            // ]
        }
    },
    watch: {
        filterSearchObj: {
            handler: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$data.searchObj = newVal;
                }
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.$data.eventTargetRecord = !isEmpty(this.filterSort) ? this.filterSort[0].sort : "";
    },
    methods: {
        filterItemEvent(event, item, index, ele) {
            let spanItems = document.querySelectorAll(".filter-form")[index].querySelector('.filter-content').querySelectorAll('.filter-item-span');
            for (let index = 0; index < spanItems.length; index++) {
                const element = spanItems[index];
                element.classList = 'filter-item-span';
            }
            event.target.classList = 'filter-item-span active';
            this.filterSearchObj[item] = ele.value;
            this.$emit("filterItemEvent", { ...this.filterSearchObj, ...this.formSearchObj, ...this.$data.selectedObj, sort: this.$data.eventTargetRecord, sortType: this.$data.sortType });
        },
        toggleContent(index) {
            let filterContent = document.querySelectorAll(".filter-form")[index].querySelector('.filter-content');
            let toggleFlag = document.querySelectorAll(".filter-form")[index].querySelector('.toggle');
            toggleFlag.dataset.flag = toggleFlag.dataset.flag == 'true' ? 'false' : 'true';
            toggleFlag.style.transform = toggleFlag.dataset.flag == 'true' ? 'rotate(-180deg)' : 'rotate(0deg)';
            filterContent.style.height = toggleFlag.dataset.flag == 'true' ? 'auto' : '28px';
        },
        moreSelectChange(options, prop) {
            if(isEmpty(options)) {
                delete this.$data.selectedObj[prop]
            } else {
                this.$data.selectedObj[prop] = options;
            }
            this.$emit("moreSelectChange", { ...this.filterSearchObj, ...this.formSearchObj, ...this.$data.selectedObj, sort: this.$data.eventTargetRecord, sortType: this.$data.sortType });
        },
        resetForm() {
            this.$refs['formSearchRef'].resetFields();
            this.$data.eventTargetRecord = !isEmpty(this.filterSort) ? this.filterSort[0].sort : "";
            this.$data.sortType = 'DESC';
            this.$data.searchObj = Object.keys(this.$data.searchObj).reduce((init, next) => ({ ...init, [next]: '' }), {});
            if (!isEmpty(this.filterSort)) {
                let elLinks = document.querySelector(".filter-sort").querySelectorAll('.el-link');
                for (let i = 0; i < elLinks.length; i++) {
                    const element = elLinks[i];
                    element.classList = "el-link";
                    elLinks[0].classList = "el-link el-link--primary";
                    element.dataset.flag = 0;
                    elLinks[0].dataset.flag = 1;
                    element.children[0].children[0].classList = "el-icon--right el-icon-d-caret";
                    elLinks[0].children[0].children[0].classList ='el-icon--right el-icon-caret-bottom';
                }
            }
            this.$emit("resetFilterEvent", { searchObj: this.$data.searchObj, formSearchObj: this.formSearchObj, sort: this.$data.eventTargetRecord, sortType: this.$data.sortType });
        },
        searchForm() {
            this.$emit("searchFilterEvent", { ...this.$data.searchObj, ...this.formSearchObj, sort: this.$data.eventTargetRecord, sortType: this.$data.sortType } );
        },
        filterSortEvent(event, index, item) {
            if (event.target.parentNode.dataset.sort !== this.$data.eventTargetRecord) {
                this.$data.sortType = 'DESC';
                this.$data.eventTargetRecord = event.target.parentNode.dataset.sort;
                let elLinks = document.querySelector(".filter-sort").querySelectorAll('.el-link');
                for (let i = 0; i < elLinks.length; i++) {
                    const element = elLinks[i];
                    element.classList = "el-link";
                    elLinks[index].classList = "el-link el-link--primary";
                    element.dataset.flag = 0;
                    elLinks[index].dataset.flag = 1;
                    element.children[0].children[0].classList = "el-icon--right el-icon-d-caret";
                    elLinks[index].children[0].children[0].classList ='el-icon--right el-icon-caret-bottom';
                }
            } else {
                let elLinks = document.querySelector(".filter-sort").querySelectorAll('.el-link');
                elLinks[index].dataset.flag = elLinks[index].dataset.flag === '1' ? '2' : '1';
                this.$data.sortType = elLinks[index].dataset.flag === '1' ? 'DESC' : 'ASC';
                elLinks[index].children[0].children[0].classList = elLinks[index].dataset.flag === '1' ? 'el-icon--right el-icon-caret-bottom' : 'el-icon--right el-icon-caret-top';
            }
            this.$emit("filterSortEvent", { ...this.$data.searchObj, ...this.formSearchObj, sort: this.$data.eventTargetRecord, sortType: this.$data.sortType } );
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-condition-container {
    >>> .el-divider {
        margin: 5px 0 15px;
    }

    .filter-sort {
        margin-top: 20px;
        .el-link {
            &:not(:first-child) {
                margin-left: 20px;
            }

            &.el-link--primary {
                font-weight: bold;
            }

            >>> .el-link--inner {
                font-size: 16px;
            }
        }
    }

    .label-position-top {
        >>> .el-form-item__label {
            line-height: 20px;
            padding-bottom: 5px;
        }
    }
    .filter-form {
        display: flex;
        padding: 12px 0;

        &:first-child {
            // padding: 10px 0;
        }

        &:not(:first-child) {
            // padding: 10px 0 0;
        }

        &:not(:first-child) {
            // border-top: 1px dotted #B6BFCC;
        }

        &:last-child {
            // padding: 20px 0 0;
        }

        &.filter-form-flex {
            align-items: center;
        }

        .filter-select {
            margin-right: 20px;
        }
    }

    
    .filter-label {
        width: 85px;
        font-size: 16px;
        line-height: 26px;
        color: #2C2E33;
        text-align: right;
    }
    .filter-content {
        flex: 1;
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
        // height: 28px;
        // overflow: hidden;
        transition: all .5;

        .filter-item-span {
            cursor: pointer;
            padding: 0 10px;
            display: inline-block;
            line-height: 24px;
            font-size: 14px;
            color: #666666;
            background: #F7FAFD;
            border: 1px solid rgba(162,178,189,0.5);
            border-radius: 4px;

            &.active,
            &:hover {
                color: #fff;
                border-radius: 4px;
                background-color: #2B69E2;
                border: 1px solid rgba(43, 105, 226, .5);
            }

            &:not(:first-child) {
                margin-left: 15px;
            }
        }
    }
    .filter-toggle {
        width: 50px;
        text-align: center;

        .toggle {
            display: inline-block;
            width: 25px;
            height: 25px;
            line-height: 25px;
            border-radius: 5px;
            border: 1px solid #AFB9CC;
            cursor: pointer;

            &:hover {
                color: #fff;
                background-color: #0090FF;
                border: 1px solid #0090FF;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/FilterCondition/index.vue